import React, { useCallback } from 'react'
import { Key, KeyboardContent, KeyboardWrap, KeyText } from './index.styled'
import MainIcon from '../../../../../img/svg/main'


const BeeperKeyboard = React.memo(({ handleType, currentValue, size }) => {
	const numbers = Array.from({ length: 10 }, (_, i) => ((i + 1) % 10).toString())
	const layout = size ? size + ' ' : ''

	const handleKeyClick = useCallback((key) => {
		handleType(currentValue + key)
	}, [currentValue, handleType])

	const handleClearClick = useCallback(() => {
		handleType('')
	}, [handleType])

	const handleDeleteClick = useCallback(() => {
		const value = currentValue.slice(0, -1)
		handleType(value)
	}, [currentValue, handleType])

	return (
		<KeyboardWrap className={layout}>
			<KeyboardContent>
				{numbers.map(number =>
					<Key className={layout + 'number'} type="button" key={number} onClick={() => handleKeyClick(number)}>
						<KeyText className="number">{number}</KeyText>
					</Key>)}

				<Key className={layout + 'clear'} type="button" onClick={handleClearClick}>
					<KeyText className="clear">CE</KeyText>
				</Key>

				<Key className={layout + 'delete'} type="button" onClick={handleDeleteClick}>
					<MainIcon icon="back-bold" />
				</Key>
			</KeyboardContent>
		</KeyboardWrap>
	)
})

BeeperKeyboard.displayName = 'BeeperKeyboard'
export default BeeperKeyboard
